<template>
  <BaseCenteredModal
    v-model:is-modal-open="localIsModalOpen"
    size="extra-large"
    :title="$t('global.disponibility')"
    @close="$emit('close')"
  >
    <template #body>
      <div
        v-if="originalRequest"
        class="flex min-h-[8rem] w-full flex-col space-y-5"
      >
        <div class="h-[60vh]">
          <AvailableItem
            v-model:original="localOriginalRequest[page]"
            v-model:new-orders="localNewOrders"
            :page="page"
            :supplier-with-orders="supplierWithOrders"
            :default-delivery="defaultDelivery"
          />
        </div>
      </div>
    </template>
    <template #footer>
      <div class="flex w-full flex-row">
        <div class="flex flex-1">
          <ItemsPagination
            v-model:original-request="localOriginalRequest"
            v-model:page="internalPage"
          />
        </div>
        <div class="shrink-O flex flex-row gap-2">
          <BaseButton
            :title="$t('button.cancel')"
            color="warning"
            @click="localIsModalOpen = false"
          />
          <BaseButton
            :title="$t('button.save')"
            :disabled="cannotSubmit"
            @click="submit"
          />
        </div>
      </div>
    </template>
  </BaseCenteredModal>
</template>

<script>
import { mapGetters } from 'vuex'
import BaseButton from '@c/addf-package/components/BaseButton/BaseButton.vue'
import BaseCenteredModal from '@c/addf-package/components/modal/BaseCenteredModal.vue'
import AvailableItem from '@c/Stock/Component/AvailableItem.vue'
import ItemsPagination from '@c/Stock/Component/ItemsPagination.vue'

export default {
  name: 'AvailableLocationStockModal',
  components: {
    ItemsPagination,
    AvailableItem,
    BaseCenteredModal,
    BaseButton
  },
  props: {
    isModalOpen: {
      type: Boolean,
      required: true
    },
    updateItem: {
      type: Boolean,
      required: false,
      default: false
    },
    originalRequest: {
      type: Array,
      required: false,
      default: () => []
    },
    newOrders: {
      type: Array,
      required: false,
      default: () => []
    },
    supplierWithOrders: {
      type: Array,
      required: false,
      default: () => []
    },
    locations: {
      type: Array,
      required: true
    },
    defaultDelivery: {
      type: Object,
      required: false,
      default: () => null
    }
  },
  emits: [
    'close',
    'update:is-modal-open',
    'update:original-request',
    'selected-items',
    'update-item-dossier',
    'update:new-orders'
  ],
  data() {
    return {
      internalPage: 0
    }
  },
  computed: {
    ...mapGetters({
      dossier: 'dossier/getDossier'
    }),
    localIsModalOpen: {
      get() {
        return this.isModalOpen
      },
      set(value) {
        this.$emit('update:is-modal-open', value)
      }
    },
    localOriginalRequest: {
      get() {
        return this.originalRequest
      },
      set(value) {
        this.$emit('update:original-request', value)
      }
    },
    localNewOrders: {
      get() {
        return this.newOrders
      },
      set(value) {
        this.$emit('update:new-orders', value)
      }
    },
    page: {
      get() {
        return this.internalPage === 0
          ? Array.isArray(this.originalRequest)
            ? (this.originalRequest.findIndex((elt) => elt.item !== null) ?? 0)
            : 0
          : this.internalPage
      },
      set(value) {
        this.internalPage = value
      }
    },
    cannotSubmit() {
      this.originalRequest.findIndex((elt) => elt.item !== null)
      return this.originalRequest.some((request) => {
        if (request.item === null) {
          return false
        }
        return (
          request.item.stockable &&
          request.quantity >
            Object.values(request.stock)
              .map((item) => item.quantity)
              .filter((n) => parseInt(n) === n)
              .reduce((a, b) => a + b, 0) +
              request.order
        )
      })
    }
  },
  methods: {
    submit() {
      if (this.updateItem) {
        this.$emit('update-item-dossier', Object.values(this.originalRequest))
      } else {
        this.$emit('selected-items', {
          type: 'item',
          selectedItem: Object.values(this.originalRequest)
        })
      }
    }
  }
}
</script>
